import { LRUCache } from 'lru-cache';
import jexl from '@code2io/jexl';
import _, { merge, zipObject, map } from 'lodash';
import 'jsonpath';
import { v4 } from 'uuid';

const expressionOnlyRegex = new RegExp(new RegExp("^\\{\\{.*?\\}\\}$", "gs"));
const expressionRegex = new RegExp(new RegExp("\\{\\{.*?\\}\\}", "gs"));

const cache = new LRUCache({
  max: 500
});

function stringConcat(...args) {
  return "".concat(...args);
}

function toLocaleString(value, locale, options) {
  return value.toLocaleString(locale, options);
}
function toLocaleDateString(value, locale, options) {
  let convertable;
  if (value instanceof Date) {
    convertable = value;
  } else {
    convertable = new Date(value);
  }
  return convertable.toLocaleDateString(locale, options);
}

function trimQuotes$1(str) {
  let res = str;
  while (res.startsWith('"')) {
    res = res.slice(1);
  }
  while (res.endsWith('"')) {
    res = res.slice(-1);
  }
  return res;
}

function withQuotes(str) {
  return '"' + trimQuotes$1(str) + '"';
}

function testRegExp(input, pattern, flags) {
  return new RegExp(pattern, flags).test(input);
}

function push(array, ele) {
  return [...array, ele];
}

function len(arr) {
  return arr.length;
}

function findDeep(arr, recursiveKey, searchKey, value) {
  if (Array.isArray(arr)) {
    return recursiveSearch(arr, recursiveKey, searchKey, value);
  } else {
    return recursiveSearch(arr[recursiveKey], recursiveKey, searchKey, value);
  }
}
function recursiveSearch(arr, key, searchKey, value) {
  let found = null;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][searchKey] === value) {
      found = arr[i];
    } else if (arr[i][key]) {
      found = recursiveSearch(arr[i][key], key, searchKey, value);
    }
  }
  if (found)
    return found;
}

function removeIndex(array, index) {
  return array.filter((ele, i) => {
    return i !== index;
  });
}

function addKey(obj, key, value) {
  obj[key] = value;
  return obj;
}

function removeKey(obj, key) {
  delete obj[key];
  return obj;
}

function mapToKey(objects, key) {
  return objects.map((obj) => {
    return obj[key];
  });
}
function filterByKeys(objects, keys) {
  return objects.map((obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([key, value]) => {
        return keys.includes(key);
      })
    );
  });
}

function fromKeysAndValues(keys, values) {
  const obj = {};
  keys.forEach((val, idx) => {
    obj[val] = values[idx];
  });
  return obj;
}

function updateKey(obj, oldKey, newKey) {
  if (!obj[oldKey] || obj[newKey]) {
    return;
  }
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (key === oldKey) {
        return [newKey, value];
      }
      return [key, value];
    })
  );
}

function uuid() {
  return v4();
}

const transformReportResponse = (response) => {
  if (!response || !response.rows)
    return [];
  return response.rows.map((row) => merge(zipObject(map(response.dimensionHeaders, "name"), map(row.dimensionValues, "value")), zipObject(map(response.metricHeaders, "name"), map(row.metricValues, "value"))));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
function trimQuotes(str) {
  if (str.startsWith('"') && str.endsWith('"')) {
    return str.slice(1, -1);
  }
  return str;
}
function parseLinkHeader(header) {
  if (typeof header !== "string") {
    return null;
  }
  const result = {};
  const links = header.split(",");
  links.forEach((link) => {
    const parts = link.split(";").map((str) => str.trim());
    if (parts.length === 0) {
      return;
    }
    const linkPart = parts[0];
    if (!linkPart.startsWith("<") || !linkPart.endsWith(">")) {
      return;
    }
    const url = new URL(linkPart.slice(1, -1));
    const searchParamsWithQuotes = Object.fromEntries(url.searchParams.entries());
    const searchParams = Object.fromEntries(
      Object.entries(searchParamsWithQuotes).map(([k, v]) => [k, trimQuotes(v)])
    );
    const paramParts = parts.slice(1);
    const relPart = paramParts.find((part) => part.startsWith("rel="));
    if (typeof relPart === "undefined") {
      return;
    }
    const rel = trimQuotes(relPart.substring(4));
    const otherParts = paramParts.filter((part) => !part.startsWith("rel="));
    const additionalParams = Object.fromEntries(otherParts.flatMap((part) => {
      if (part.split("=").length < 2) {
        return [];
      }
      return [[
        part.split("=")[0],
        trimQuotes(part.split("=")[1])
      ]];
    }));
    result[rel] = __spreadValues$2(__spreadValues$2({
      rel,
      url: url.toString()
    }, searchParams), additionalParams);
  });
  return result;
}

const customFunctions = {
  stringConcat,
  convertLocaleString: toLocaleString,
  convertLocaleDateString: toLocaleDateString,
  push,
  addKey,
  removeKey,
  mapToKey,
  filterByKeys,
  fromEntries: Object.fromEntries,
  fromKeysAndValues,
  uuid,
  len,
  updateKey,
  findDeep,
  removeIndex,
  jsonStringify: JSON.stringify,
  jsonParse: (arg) => {
    if (typeof arg === "string") {
      return JSON.parse(arg);
    }
    return arg;
  },
  withQuotes,
  trimQuotes: trimQuotes$1,
  testRegExp,
  fetch: (url, options) => {
    return new Promise((resolve, reject) => {
      fetch(url, options).then((response) => response.json()).then(resolve).catch(reject);
    });
  },
  getQueryParameter: (url, key) => {
    var _a;
    return (_a = new URL(url).searchParams.get(key)) != null ? _a : "";
  },
  getQueryParameters: (url, key) => {
    var _a;
    return (_a = new URL(url).searchParams.getAll(key)) != null ? _a : [];
  },
  now: () => (/* @__PURE__ */ new Date()).toISOString(),
  getDay: (date) => new Date(date).getDate(),
  // day of month (1 indexed)
  getMonth: (date) => new Date(date).getMonth(),
  // 0 indexed
  getYear: (date) => new Date(date).getFullYear(),
  encodeURL: (url) => encodeURIComponent(url),
  decodeURL: (url) => decodeURIComponent(url),
  gaTransformReportResponse: transformReportResponse,
  parseLinkHeader,
  toBoolean: (arg) => {
    if (arg === "" || arg === null || typeof arg === "undefined") {
      return null;
    }
    return Boolean(arg);
  }
};
function getFunctionNames() {
  return [
    ...Object.entries(_).filter(([, fn]) => typeof fn === "function").map(([name]) => name),
    ...Object.keys(customFunctions)
  ];
}
const functionsThatUseJexlContext = {
  connectionInfo: (connection, jexlContext) => {
    return new Promise((resolve, reject) => {
      const tokenServiceAddress = process.env.TOKEN_SERVICE_INTERNAL_ADDRESS;
      if (typeof tokenServiceAddress === "undefined") {
        reject("Token service address is not defined");
        return;
      }
      const appId = jexlContext["appId"];
      if (typeof appId === "undefined") {
        reject("Did not receive appId in context");
        return;
      }
      const url = new URL(
        `${tokenServiceAddress}/internal/connection/${appId}/${connection.id}`
      );
      fetch(url.toString()).then((response) => response.json()).then(resolve).catch(reject);
    });
  }
};
function getFunctionMap() {
  const functions = {};
  Object.entries(_).forEach(([name, fn]) => {
    if (typeof fn === "function") {
      functions[name] = (...args) => {
        return fn(...args.slice(0, -1));
      };
    }
  });
  Object.entries(customFunctions).forEach(([name, fn]) => {
    functions[name] = (...args) => {
      return fn(...args.slice(0, -1));
    };
  });
  Object.entries(functionsThatUseJexlContext).forEach(([name, fn]) => {
    functions[name] = fn;
  });
  return functions;
}
function init(jexlRef) {
  Object.entries(getFunctionMap()).forEach(([key, value]) => {
    jexlRef.addFunction(key, value);
  });
  jexlRef.addBinaryOp("===", 20, (left, right) => {
    return left === right;
  });
  jexlRef.addBinaryOp("!==", 20, (left, right) => {
    return left !== right;
  });
  jexlRef.removeOp("in");
}

init(jexl);

const getPaths = (expression) => {
  try {
    const ast = jexl.compile(expression)._getAst();
    if (!ast) {
      return [];
    }
    const paths = [];
    const path = [];
    traverseJexlAST(ast, paths, path);
    return paths;
  } catch (err) {
    return [];
  }
};
const traverseJexlAST = (node, paths, path) => {
  switch (node.type) {
    case "Identifier": {
      if (typeof node.from !== "undefined") {
        traverseJexlAST(node.from, paths, [...path, node.value]);
        break;
      }
      paths.push([...path, node.value]);
      break;
    }
    case "FunctionCall": {
      if (path.length > 0) {
        paths.push(path);
      }
      node.args.forEach((tree) => {
        traverseJexlAST(tree, paths, []);
      });
      break;
    }
    case "ObjectLiteral": {
      if (path.length > 0) {
        paths.push(path);
      }
      Object.values(node.value).forEach((tree) => {
        traverseJexlAST(tree, paths, []);
      });
      break;
    }
    case "ArrayLiteral": {
      if (path.length > 0) {
        paths.push(path);
      }
      node.value.forEach((tree) => {
        traverseJexlAST(tree, paths, []);
      });
      break;
    }
    case "Literal":
      break;
    case "FilterExpression": {
      if (node.expr.type === "Literal") {
        traverseJexlAST(node.subject, paths, [
          ...path,
          node.expr.value.toString()
        ]);
        break;
      }
      traverseJexlAST(node.expr, paths, []);
      traverseJexlAST(node.subject, paths, []);
      break;
    }
    case "ConditionalExpression": {
      traverseJexlAST(node.test, paths, path);
      traverseJexlAST(node.consequent, paths, path);
      traverseJexlAST(node.alternate, paths, path);
      break;
    }
    case "BinaryExpression": {
      traverseJexlAST(node.left, paths, path);
      traverseJexlAST(node.right, paths, path);
      break;
    }
    case "UnaryExpression": {
      traverseJexlAST(node.right, paths, path);
      break;
    }
  }
};

function isExpression(expr) {
  const matches = expr.match(expressionRegex);
  return matches !== null && matches.length > 0;
}
function trimJexlCurlyBraces(str) {
  return str.slice(2, -2);
}
function getExpressions(str) {
  const matches = str.match(expressionRegex);
  if (matches === null) {
    return [];
  }
  return matches.map(trimJexlCurlyBraces);
}
function getIdentifierPaths(expr) {
  const expressions = getExpressions(expr);
  const paths = expressions.flatMap(getPaths);
  return paths.map((path) => path.reverse());
}

function evaluate(expression, context) {
  if (typeof expression !== "string") {
    return;
  }
  const singleExprMatch = expression.match(expressionOnlyRegex);
  const multipleExprMatch = expression.match(expressionRegex);
  const doEvaluateWithoutStringReplace = singleExprMatch !== null && (multipleExprMatch && multipleExprMatch.length === 1);
  if (doEvaluateWithoutStringReplace) {
    const match = singleExprMatch[0];
    const expr = trimJexlCurlyBraces(match);
    return evaluateExpr$1(expr, context);
  }
  if (multipleExprMatch === null) {
    return expression;
  }
  return expression.replace(expressionRegex, (match) => {
    const expr = trimJexlCurlyBraces(match);
    const result = evaluateExpr$1(expr, context);
    if (typeof result === "object") {
      return JSON.stringify(result);
    }
    return result;
  });
}
function evaluateExpr$1(expression, context) {
  if (expression.length === 0) {
    return expression;
  }
  if (!cache.get(expression)) {
    cache.set(expression, jexl.compile(expression));
  }
  return cache.get(expression).evalSync(context);
}

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
function processPayloadTemplate(template, input) {
  var _a;
  if (template === void 0 || template === null || typeof template !== "object") {
    return template;
  }
  const ignoreKeys = (_a = template["__ignoreKeys"]) != null ? _a : [];
  const objectFromIgnoredKeys = Object.fromEntries(
    Object.entries(template).filter(([key]) => ignoreKeys.includes(key) && key !== "__ignoreKeys")
  );
  const payloadTemplate = Object.fromEntries(
    Object.entries(template).filter(([key]) => !ignoreKeys.includes(key) && key !== "__ignoreKeys")
  );
  const result = traverseContext$1(payloadTemplate, input);
  if (typeof objectFromIgnoredKeys !== "object" || typeof result !== "object") {
    return {};
  }
  return __spreadValues$1(__spreadValues$1({}, objectFromIgnoredKeys), result);
}
function traverseContext$1(node, input) {
  if (Array.isArray(node)) {
    return node.map((entry) => traverseContext$1(entry, input));
  }
  if (node === null) {
    return null;
  }
  if (typeof node === "object") {
    return Object.fromEntries(
      Object.entries(node).map(([key, value]) => {
        return [key, traverseContext$1(value, input)];
      })
    );
  }
  if (typeof node === "string") {
    return evaluate(node, input);
  }
  return node;
}

function evaluateChoiceRule(choiceRules, input) {
  const rules = choiceRules.Choices;
  for (let i = 0; i < rules.length; i++) {
    const expr = rules[i].Variable;
    const result = evaluate(expr, input);
    if (result) {
      return {
        Next: rules[i].Next
      };
    }
  }
  return {
    Next: choiceRules.Default
  };
}

var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function evaluateAsync(expression, context) {
  return __async$2(this, null, function* () {
    if (typeof expression !== "string") {
      return;
    }
    const singleExprMatch = expression.match(expressionOnlyRegex);
    const multipleExprMatch = expression.match(expressionRegex);
    const doEvaluateWithoutStringReplace = singleExprMatch !== null && (multipleExprMatch && multipleExprMatch.length === 1);
    if (doEvaluateWithoutStringReplace) {
      const match = singleExprMatch[0];
      const expr = match.slice(2, -2);
      return yield evaluateExpr(expr, context);
    }
    if (multipleExprMatch === null) {
      return expression;
    }
    const evalResults = yield Promise.all(
      multipleExprMatch.map((match) => {
        return new Promise((resolve, reject) => {
          const expr = match.slice(2, -2);
          evaluateExpr(expr, context).then(resolve);
        });
      })
    );
    const mapping = Object.fromEntries(
      multipleExprMatch.map((match, index) => {
        return [match, evalResults[index]];
      })
    );
    return expression.replace(expressionRegex, (match) => {
      const result = mapping[match];
      if (typeof result === "object") {
        return JSON.stringify(result);
      }
      return String(result);
    });
  });
}
function evaluateExpr(expression, context) {
  return __async$2(this, null, function* () {
    var _a;
    if (expression.length === 0) {
      return expression;
    }
    if (!cache.get(expression)) {
      cache.set(expression, jexl.compile(expression));
    }
    return yield (_a = cache.get(expression)) == null ? void 0 : _a.eval(context);
  });
}

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function processPayloadTemplateAsync(template, input) {
  return __async$1(this, null, function* () {
    return new Promise((resolve, reject) => {
      var _a;
      if (template === void 0 || template === null || typeof template !== "object") {
        resolve(template);
      }
      const ignoreKeys = (_a = template["__ignoreKeys"]) != null ? _a : [];
      const objectFromIgnoredKeys = Object.fromEntries(
        Object.entries(template).filter(([key]) => ignoreKeys.includes(key) && key !== "__ignoreKeys")
      );
      const payloadTemplate = Object.fromEntries(
        Object.entries(template).filter(([key]) => !ignoreKeys.includes(key) && key !== "__ignoreKeys")
      );
      traverseContext(payloadTemplate, input).then((result) => {
        if (typeof objectFromIgnoredKeys !== "object" || typeof result !== "object") {
          resolve({});
          return;
        }
        resolve(__spreadValues(__spreadValues({}, objectFromIgnoredKeys), result));
      }).catch(reject);
    });
  });
}
function traverseContext(node, input) {
  return __async$1(this, null, function* () {
    if (Array.isArray(node)) {
      return new Promise((resolve, reject) => {
        Promise.all(node.map((entry) => {
          return new Promise((resolve2) => {
            traverseContext(entry, input).then(resolve2);
          });
        })).then(resolve).catch(reject);
      });
    }
    if (node === null) {
      return Promise.resolve(null);
    }
    if (typeof node === "object") {
      const promises = Object.entries(node).map(([, value]) => {
        return new Promise((resolve, reject) => {
          traverseContext(value, input).then(resolve).catch(reject);
        });
      });
      return new Promise((resolve, reject) => {
        Promise.all(promises).then((results) => {
          resolve(Object.fromEntries(
            Object.keys(node).map((key, index) => {
              return [key, results[index]];
            })
          ));
        }).catch(reject);
      });
    }
    if (typeof node === "string") {
      return new Promise((resolve, reject) => {
        evaluateAsync(node, input).then(resolve).catch(reject);
      });
    }
    return Promise.resolve(node);
  });
}

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function evaluateChoiceRuleAsync(choiceRules, input) {
  return __async(this, null, function* () {
    const rules = choiceRules.Choices;
    const promises = rules.map((rule) => {
      return new Promise((resolve) => {
        evaluateAsync(rule.Variable, input).then(resolve).catch(() => resolve(false));
      });
    });
    const results = yield Promise.all(promises);
    const index = results.findIndex(Boolean);
    if (index > -1) {
      return {
        Next: rules[index].Next
      };
    }
    return {
      Next: choiceRules.Default
    };
  });
}

function validateSingle(expr, context) {
  const errors = [];
  try {
    jexl.evalSync(expr, context != null ? context : {});
  } catch (err) {
    errors.push(err.message);
  }
  if (errors.length > 0) {
    return {
      success: false,
      errors
    };
  }
  return {
    success: true
  };
}
function validate(expr, context) {
  const expressions = expr.match(expressionRegex);
  if (expressions === null) {
    return {
      success: true
    };
  }
  const errors = [];
  expressions.forEach((expressionWithBraces) => {
    const expression = expressionWithBraces.slice(2, -2);
    try {
      jexl.evalSync(expression, context != null ? context : {});
    } catch (err) {
      errors.push(err.message);
    }
  });
  if (errors.length > 0) {
    return {
      success: false,
      errors
    };
  }
  return {
    success: true
  };
}

function parse(expr) {
  const parts = [];
  const esc = "\\";
  const left = "{{", right = "}}";
  let between = false;
  let builder = "";
  for (let i = 0; i < expr.length; i++) {
    const escaped = i > 0 && expr[i - 1] === esc;
    if (!between && expr.substring(i, i + 2) === left && !escaped) {
      between = true;
      if (i !== 0) {
        parts.push({
          type: "str",
          value: builder
        });
        builder = "";
      }
      i += 1;
    } else if (between && expr.substring(i, i + 2) === right && !escaped) {
      between = false;
      i += 1;
      parts.push({
        type: "expr",
        value: builder
      });
      builder = "";
    } else if (!(expr[i] === esc && i < expr.length - 1 && (expr.substring(i + 1, i + 3) === left || expr.substring(i + 1, i + 3) === right))) {
      builder += expr[i];
    }
  }
  if (builder.length > 0) {
    parts.push({
      type: "str",
      value: builder
    });
  }
  return parts;
}

export { evaluate, evaluateChoiceRule, evaluateChoiceRuleAsync, getExpressions, getFunctionNames, getIdentifierPaths, getPaths, isExpression, parse, processPayloadTemplate, processPayloadTemplateAsync, validate, validateSingle };
//# sourceMappingURL=index.mjs.map
